/* tslint:disable */
/* eslint-disable */
/**
 * MG-DX Personal Health Record API
 * API for PHR
 *
 * The version of the OpenAPI document: 0.2.0
 * Contact: developers@mg-dx.co.jp
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { tzDate } from "@mgdx-libs/dayjs";
import { exists, mapValues } from "../runtime";
import {
  PhrMedicalExpenseNotification,
  PhrMedicalExpenseNotificationFromJSON,
  PhrMedicalExpenseNotificationFromJSONTyped,
  PhrMedicalExpenseNotificationToJSON,
  PhrMedicalTreatment,
  PhrMedicalTreatmentFromJSON,
  PhrMedicalTreatmentFromJSONTyped,
  PhrMedicalTreatmentToJSON,
  PhrSpecificHealthCheckup,
  PhrSpecificHealthCheckupFromJSON,
  PhrSpecificHealthCheckupFromJSONTyped,
  PhrSpecificHealthCheckupToJSON,
} from "./";

export const PhrPersonalHealthRecordTypename = "PhrPersonalHealthRecord" as const;

/**
 *
 * @export
 * @interface PhrPersonalHealthRecord
 */
export interface PhrPersonalHealthRecord {
  /**
   *
   * @type {Array<PhrMedicalExpenseNotification>}
   * @memberof PhrPersonalHealthRecord
   */
  medicalExpenseNotifications?: Array<PhrMedicalExpenseNotification>;
  /**
   *
   * @type {Array<PhrMedicalTreatment>}
   * @memberof PhrPersonalHealthRecord
   */
  medicalTreatments?: Array<PhrMedicalTreatment>;
  /**
   *
   * @type {Array<PhrSpecificHealthCheckup>}
   * @memberof PhrPersonalHealthRecord
   */
  specificHealthCheckups?: Array<PhrSpecificHealthCheckup>;
  /**
   * Resource type name
   * @type {string}
   * @memberof PhrPersonalHealthRecord
   */
  readonly __typename?: string;
}

export function PhrPersonalHealthRecordFromJSON(json: any): PhrPersonalHealthRecord {
  return PhrPersonalHealthRecordFromJSONTyped(json, false);
}

export function PhrPersonalHealthRecordFromJSONTyped(json: any, ignoreDiscriminator: boolean): PhrPersonalHealthRecord {
  if (json === undefined || json === null) {
    return json;
  }
  return {
    __typename: PhrPersonalHealthRecordTypename,

    medicalExpenseNotifications: !exists(json, "medical_expense_notifications")
      ? undefined
      : (json["medical_expense_notifications"] as Array<any>).map(PhrMedicalExpenseNotificationFromJSON),
    medicalTreatments: !exists(json, "medical_treatments")
      ? undefined
      : (json["medical_treatments"] as Array<any>).map(PhrMedicalTreatmentFromJSON),
    specificHealthCheckups: !exists(json, "specific_health_checkups")
      ? undefined
      : (json["specific_health_checkups"] as Array<any>).map(PhrSpecificHealthCheckupFromJSON),
  };
}

export function PhrPersonalHealthRecordToJSON(object?: PhrPersonalHealthRecord | null): any {
  if (object === undefined) {
    return undefined;
  }
  if (object === null) {
    return null;
  }
  const { __typename, ...value } = object;
  return {
    medical_expense_notifications:
      value.medicalExpenseNotifications === undefined
        ? undefined
        : (value.medicalExpenseNotifications as Array<any>).map(PhrMedicalExpenseNotificationToJSON),
    medical_treatments:
      value.medicalTreatments === undefined
        ? undefined
        : (value.medicalTreatments as Array<any>).map(PhrMedicalTreatmentToJSON),
    specific_health_checkups:
      value.specificHealthCheckups === undefined
        ? undefined
        : (value.specificHealthCheckups as Array<any>).map(PhrSpecificHealthCheckupToJSON),
  };
}
